module.exports = __webpack_public_path__ + "img/20006fd.svg";